import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import styles from "./TablesAndFiguresMenu.module.scss";
import GuidelineMenuLink from "../../../components/Guideline/GuidelineMenuLink";
import { useDispatch } from "react-redux";
import { resetState } from "../../counter/counterSlice";
import { getGuidelineList } from "../../../utils/getConstants";

const TablesAndFiguresMenu = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const unorderedListClass = classNames("list-unstyled", "guideline-areas", styles.guidelineList);

  const handleClick = (onClickProps) => {
    dispatch(resetState());
    navigate(`/resources/tables-and-figures/${onClickProps?.replaceAll(" ", "_")}`);
  };

  return (
    <div className={styles.content}>
      <div className={styles.header}>Tables and figures</div>
      <ul className={unorderedListClass} role="navigation" aria-label="Guidelines Navigation">
        {getGuidelineList().map(({ iconClassSuffix, linkText, onClickProps }, index) => (
          <li key={`ind-${index}`}>
            <GuidelineMenuLink
              iconClassSuffix={iconClassSuffix}
              linkText={linkText}
              showArrowIcon={true}
              onClickAction={() => handleClick(onClickProps)}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TablesAndFiguresMenu;
